import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";

import SiteIcons from "@/components/SiteIcons/SiteIcons";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

function TemplateFallback({ error }) {
  const [copyStatus, setCopyStatus] = useState("");
  const { templateData, affiliateFileData } = useUpdateDataContext();
  const navigate = useNavigate();
  const { user } = useAuth0();

  const goBack = () => {
    navigate("/membership/update-data/select-file");
  };

  // It's indented this way so it copies with correct indentation (sorry).
  const errorDetailsToCopy = `Error Message: ${error.message}
Local: ${user.org_name}
Template: ${templateData.name} ${templateData.created}
Affiliate Data File: ${affiliateFileData.name} ${affiliateFileData.created}
${error.stack}
Component Props (if available via component stack): ${error.componentStack || "Not available"}`.trim();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(errorDetailsToCopy);
      setCopyStatus("Copied!");
      setTimeout(() => setCopyStatus(""), 2000); // Clear message after 2 seconds
    } catch (err) {
      console.error("Failed to copy error details: ", err);
      setCopyStatus("Failed to copy!");
      setTimeout(() => setCopyStatus(""), 2000);
    }
  };

  return (
    <Box sx={{ padding: "22px" }} id="template-error-boundary">
      <Typography
        sx={{
          fontSize: "1.3rem",
          marginBottom: "3px",
        }}
      >
        Oops! Something went wrong.
      </Typography>
      <Typography>
        You can help us out by copying and pasting this error into an email or
        slack message to your data support person.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "right", marginTop: "10px" }}>
        <Button
          className="siteBlue"
          onClick={(e) => {
            handleCopy();
          }}
        >
          <SiteIcons
            iconstring="copy"
            color="white"
            sx={{ marginRight: "5px" }}
          />
          {copyStatus || "Copy"}
        </Button>

        <Button className="siteBlueOutlined" onClick={goBack}>
          Go Back
        </Button>
      </Box>

      <details>
        <Typography sx={{ fontFamily: "monospace" }}>
          Error: {error.message}
          <br></br>
          Local: {user.org_name}
          <br></br>
          Template: {templateData.name} {templateData.created}
          <br></br>
          Affiliate Data File: {affiliateFileData.name}{" "}
          {affiliateFileData.created}
          <br></br>
          {error.stack}
        </Typography>
      </details>
    </Box>
  );
}

export default TemplateFallback;
